export default function Footer() {
  const services = [
    { label: 'Manufacturing Surveillance', href: '/services' },
    { label: 'Material Verification', href: '/services' },
    { label: 'Welding Oversight', href: '/services' },
    { label: 'NDT Witness', href: '/services' },
    { label: 'Coating Inspection', href: '/services' },
    { label: 'Supplier Surveillance', href: '/services' },
  ];

  return (
    <footer className="bg-dark-primary border-t border-dark-border/30 py-20">
      <div className="max-w-6xl mx-auto px-8">
        {/* ONE SHARED GRID (TOP + BOTTOM) */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
          {/* TOP ROW — Left */}
          <div>
            <h3 className="text-white text-lg font-semibold mb-5 tracking-wide">
              ARVAKON
            </h3>
            <p className="text-industrial-light text-sm leading-[1.75]">
              Independent technical verification services for industrial manufacturing operations.
            </p>
          </div>

          {/* TOP ROW — Center (Services truly centered) */}
          <div className="md:flex md:justify-center">
            <div className="w-fit">
              <h4 className="text-industrial-lighter text-xs font-semibold uppercase tracking-wider mb-5">
                Services
              </h4>
              <ul className="space-y-3">
                {services.map((item) => (
                  <li key={item.label}>
                    <a
                      href={item.href}
                      className="text-industrial-light text-sm hover:text-white transition-colors"
                    >
                      {item.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          </div>

          {/* TOP ROW — Right (Information) */}
          <div>
            <h4 className="text-industrial-lighter text-xs font-semibold uppercase tracking-wider mb-5">
              Information
            </h4>
            <ul className="space-y-3">
              <li>
                <a
                  href="/about"
                  className="text-industrial-light text-sm hover:text-white transition-colors"
                >
                  About Arvakon
                </a>
              </li>
              <li>
                <a
                  href="/standards"
                  className="text-industrial-light text-sm hover:text-white transition-colors"
                >
                  Standards Reference
                </a>
              </li>
              <li>
                <a
                  href="/projects"
                  className="text-industrial-light text-sm hover:text-white transition-colors"
                >
                  Industry Applications
                </a>
              </li>
              <li>
                <a
                  href="/contact"
                  className="text-industrial-light text-sm hover:text-white transition-colors"
                >
                  Technical Inquiry
                </a>
              </li>
              <li className="pt-2 border-t border-dark-border/20">
                <a
                  href="tel:+902329701387"
                  className="text-industrial-light text-sm hover:text-white transition-colors"
                >
                  +90 232 970 13 87
                </a>
              </li>
              <li>
                <a
                  href="mailto:technical@arvakon.com?subject=Technical%20Inquiry%20-%20Arvakon"
                  className="text-industrial-light text-sm hover:text-white transition-colors"
                >
                  technical@arvakon.com
                </a>
              </li>
            </ul>
          </div>

          {/* DIVIDER — full width (same as your previous divider) */}
          <div className="col-span-1 md:col-span-3 mt-12 pt-8 border-t border-dark-border/30" />

          {/* BOTTOM BAR — Left (same grid col 1) */}
          <p className="text-industrial-muted text-xs">
            © 2024 ARVAKON. Independent Technical Verification Services.
          </p>

          {/* BOTTOM BAR — Center (same grid col 2, same centering logic as Services) */}
          <div className="md:flex md:justify-center">
            <p className="text-industrial-muted text-xs w-fit">
              Registered in Türkiye
            </p>
          </div>

          {/* BOTTOM BAR — Right (same grid col 3) */}
          <div className="flex gap-6 md:justify-start">
            <a
              href="/privacy-policy"
              className="text-industrial-muted text-xs hover:text-industrial-light transition-colors"
            >
              Privacy Policy
            </a>
            <a
              href="/terms-of-service"
              className="text-industrial-muted text-xs hover:text-industrial-light transition-colors"
            >
              Terms of Service
            </a>
          </div>

          {/* LEGAL ENTITY BLOCK (unchanged) */}
          <div className="col-span-1 md:col-span-3 mt-10 pt-6 border-t border-dark-border/20 text-center">
            <p className="text-[11px] text-industrial-muted opacity-60 leading-[1.8] text-center max-w-2xl mx-auto">
              ARVAKON operates under CHAIN Endüstriyel Makine İnşaat Sanayi ve Ticaret Limited Şirketi as its legal entity. Registered in Türkiye.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}